const url = '/document-counters';
const Provider = 'DocumentCounters';
const dbModel = 'DocumentCounters';

export { url, Provider, dbModel };
